// @ts-strict-ignore
import { UndoRedoManager } from '@shared/undo/undo-redo.manager';
import { PermissionsNavigationModel } from '@project/components/permissions/permissions-navigation.model';
import { PermissionsNavigationOperation } from '@project/components/permissions/permissions-navigation.operation';
import { ProjectNavigationModelState } from '@project-navigation/service/project-navigation-model-state';
import { IOperation } from '@shared/undo/operation/i-operation';
import { ArrayUtils } from '@shared/util/array-utils';

export class UndoRedoPermissionsNavigationManager extends UndoRedoManager {

  private previousSearchText: string = '';

  constructor(private model: PermissionsNavigationModel) {
    super();
  }

  public clearAll(): void {
    super.clearAll();
    this.previousSearchText = '';
  }

  public pushUndoOperation(oldState: ProjectNavigationModelState, newState: ProjectNavigationModelState): void {
    oldState.searchText = this.previousSearchText;
    this.previousSearchText = newState.searchText;
    super.pushUndo(new PermissionsNavigationOperation(this.model, oldState, newState));
  }

  public getLastState(): ProjectNavigationModelState {
    if (ArrayUtils.isEmpty(this.undoStack)) {
      return null;
    }
    this.clearRedo();
    this.filterUndo((operation: IOperation) => (operation instanceof PermissionsNavigationOperation && !operation.oldState.searchMode));
    const lastUndoBeforeSearch: IOperation = this.popUndo();
    if (!lastUndoBeforeSearch) {
      return null;
    }
    return (lastUndoBeforeSearch as PermissionsNavigationOperation).oldState;
  }
}
